/**
 * Fundo animado de superfícies de autenticação: nasceu no login
 * (`paginas/entrar.tsx`), pensado para a landing usar depois — por isso vive
 * em `componentes/`, não em `componentes/entrar/`.
 *
 * Sempre `absolute inset-0`, `pointer-events-none`: quem monta a página
 * decide o `position: relative` do pai e o que fica por cima. Toda cor sai
 * de token `--color-auth-*` (ver `estilos.css`) — nada escrito na mão aqui.
 *
 * As classes `.auth-aurora*` fazem o trabalho pesado (gradiente, blur,
 * máscara radial, ruído em SVG); este componente só monta a estrutura de
 * camadas e aplica a deriva lenta de cada blob via `animate-auth-deriva-*`.
 * `prefers-reduced-motion`/`[data-movimento='reduzido']` já zeram qualquer
 * `animation-duration` no projeto inteiro (`estilos.css`), então a deriva
 * some sozinha sem lógica extra aqui.
 */
export function AuroraBackground(): JSX.Element {
  return (
    <div
      aria-hidden
      className="auth-aurora pointer-events-none absolute inset-0 overflow-hidden"
    >
      <div className="auth-aurora__blob auth-aurora__blob--a animate-auth-deriva-a" />
      <div className="auth-aurora__blob auth-aurora__blob--b animate-auth-deriva-b" />
      <div className="auth-aurora__blob auth-aurora__blob--c animate-auth-deriva-c" />
      <div className="auth-aurora__grade" />
      <div className="auth-aurora__grao" />
    </div>
  );
}
